import React, { Component } from "react";
import { Spin, Select, Input, Tag } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import FiltroCategoriasInsumosItem from "./FiltroCategoriasInsumosItem";
import { tipoMatrizInfo } from "../Pages/Panel/Matrices/matriz.utils";
import './Styles.css';

const { Option } = Select;

class SelectInsumosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      texto: '',
      filtros: [], // [{categoriaId, categoriaNombre, valorId, valorLabel, tipoDato}]
    };
    this.insumoPrevioAlCambiarCliente = null;

    this.buscarInsumos = debounce(this.buscarInsumos.bind(this), 300);
  }

  // `cargarAlAbrir`: para tablas con cientos de renglones (p. ej. la plantilla de productos
  // del proveedor), donde un POST por renglón al montar satura el back. Un select sin valor
  // no consulta hasta que se abre el desplegable o se escribe.
  //
  // Este componente se usa en todo el sistema: el modo solo se activa si se pide
  // explícitamente con `cargarAlAbrir={true}` y en selección simple. Cualquier otro uso
  // (sin la prop, con otro valor, mode="multiple"/"tags") sigue el camino de siempre.
  usaCargaAlAbrir() {
    return (
      this.props.cargarAlAbrir === true &&
      this.props.mode !== "multiple" &&
      this.props.mode !== "tags"
    );
  }

  // La opción del valor actual entre las cargadas, para conservarla cuando la primera
  // apertura en modo `cargarAlAbrir` reemplaza las opciones. Nunca truena: ante un valor
  // u opción inesperados regresa null y solo se pierde esa preservación.
  opcionSeleccionadaActual() {
    try {
      const { value } = this.props;
      if (value === undefined || value === null || value === "" || Array.isArray(value)) return null;
      return (
        (this.state.opciones || []).find(
          (insumo) => insumo && insumo._id !== undefined && insumo._id !== null && String(insumo._id) === String(value)
        ) || null
      );
    } catch (error) {
      return null;
    }
  }

  componentDidMount() {
    if(this.props.insumoPreCargado){
      this.setState({
        opciones: [this.props.insumoPreCargado],
        primerCarga: false,
        cargando: false
      })
    }else if (this.usaCargaAlAbrir() && !this.props.value) {
      // Sin valor no hay etiqueta que mostrar: el catálogo se trae al abrir el desplegable
    }else{
      this.buscarInsumos('', true);
    }
  }

  componentDidUpdate(prevProps) {
     if (prevProps.insumoPreCargado !== this.props.insumoPreCargado && this.props.insumoPreCargado) {
        this.setState({
          opciones: [this.props.insumoPreCargado],
          primerCarga: false
        });
        return;
      }

    if (prevProps.clienteId !== this.props.clienteId || prevProps.usarPrecioCliente !== this.props.usarPrecioCliente) {
      this.insumoPrevioAlCambiarCliente = this.props.value
        ? this.state.opciones.find((insumo) => insumo._id.toString() === this.props.value.toString()) || this.props.insumoPreCargado
        : null;
      this.setState({ opciones: [] }, () => {
        this.buscarInsumos('', true);
      });
      return;
    }

    if (prevProps.value !== this.props.value) {
      if (this.props.value) {

        const insumoEnEstado = this.state.opciones.find(insumo => insumo._id.toString() === this.props.value.toString());

        if (!insumoEnEstado) {
          if (this.props.insumoPreCargado && this.props.insumoPreCargado._id.toString() === this.props.value.toString()) {
            this.setState({ opciones: [this.props.insumoPreCargado] });
          } else {
            this.buscarInsumos(this.props.value || '', true);
          }
        }
      }else if (this.usaCargaAlAbrir()) {
        this.yaCargoAlAbrir = false;
        this.setState({ opciones: [] });
      }else {
        this.setState({ opciones: [] }, () => {
           this.buscarInsumos('', true);
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.buscarInsumos && this.buscarInsumos.cancel) {
      this.buscarInsumos.cancel();
    }
  }

  // `ignorarValor` fuerza una búsqueda con query vacía (los primeros N insumos)
  // aunque el select ya tenga un valor. Sin él, `texto || this.props.value` haría
  // que una búsqueda vacía buscara por el _id y devolviera solo ese insumo.
  async buscarInsumos(texto, primerCarga, append = false, ignorarValor = false) {
    const valorComoQuery = ignorarValor ? undefined : this.props.value;
    this.setState({ cargando: true, primerCarga: primerCarga && this.esIdMongoDB(texto) });
    try {
      let url = "insumos/selectInsumosItemVentaFuncion";

      if (this.props.tiposInsumos === "venta") {
        url = "insumos/selectInsumosItemVentaFuncion";
      } else if (this.props.tiposInsumos === "ventaOnline") {
        url = "insumos/selectInsumosItemVentaOnlineFuncion";
      } else if (this.props.tiposInsumos === "inventariables") {
        url = "insumos/selectInsumosItemInventariableFuncion";
      } else if (this.props.tiposInsumos === "inventariablesConEquivalencias") {
        url = "insumos/selectInsumosItemInventariableConEquivalenciasFuncion";
      } else if (this.props.tiposInsumos === "compra") {
        url = "insumos/selectInsumosItemCompraFuncion";
      } else if (this.props.tiposInsumos === "inventariablesLotes") {
        url = "insumos/selectInsumosItemInventariableLotesFuncion";
      } else if (this.props.tiposInsumos === "inventariablesEquivalencias") {
        url = "insumos/selectInsumosItemInventariablesEquivalenciasFuncion";
      } else if (this.props.tiposInsumos === "inventariablesEquivalenciasMatrices") {
        url = "insumos/selectInsumosItemInventariablesEquivalenciasMatricesFuncion";
      } else if (this.props.tiposInsumos === "activos") {
        url = "insumos/selectInsumosItemActivosFuncion";
      }else if (this.props.tiposInsumos === "proveedorSinRelacion") {
        url = "insumos/selectInsumosSinRelacionProveedor";
      }else if (this.props.tiposInsumos === "generalesCosteo") {
        url = "insumos/selectInsumosGeneralesCosteoFuncion";
      }else if (this.props.tiposInsumos === "generales") {
        url = "insumos/selectInsumosGenerales";
      }else if (this.props.tiposInsumos === "ordenDeCompra") {
        url = "insumos/selectInsumosRelacionesProveedor";
      }else if (this.props.tiposInsumos === "matrices") {
        url = "insumos/selectInsumosItemMatricesFuncion";
      }
      const res = await axios.post(
        url,
        {
          empresaId: this.props.empresaId,
          query: append ? (this.state.texto || texto || valorComoQuery) : (texto || valorComoQuery),
          skip: append ? this.state.opciones.length : 0,   // saltar los ya cargados
          proveedorId: this.props.proveedorId || null,
          clienteId: this.props.clienteId || null,
          usarPrecioCliente: this.props.usarPrecioCliente,
          blockId: this.props.blockId || null,
          filtrosCategorias: this.state.filtros.map((f) => f.valorId),
          usarSistema: this.props.usarSistema || false,
          excluirIds: this.props.excluirIds || null,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        let nuevasOpciones = append ? [...this.state.opciones, ...res.data.insumos] : res.data.insumos;
        if (!append && this.insumoPrevioAlCambiarCliente && this.props.value) {
          const sigueApareciendo = nuevasOpciones.some(
            (insumo) => insumo._id.toString() === this.props.value.toString()
          );
          if (!sigueApareciendo) {
            nuevasOpciones = [this.insumoPrevioAlCambiarCliente, ...nuevasOpciones];
          }
        }
        this.insumoPrevioAlCambiarCliente = null;
        this.setState({
          opciones: nuevasOpciones,
          primerCarga: false,
          texto: append ? this.state.texto : texto
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar insumos:", error);
      this.setState({ opciones: [], texto: append ? this.state.texto : texto });
    } finally {
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }

  esIdMongoDB(valor) {
    return valor && typeof valor === 'string' && /^[0-9a-fA-F]{24}$/.test(valor);
  }

  onFiltrosChange = (nuevosFiltros) => {
    this.setState({ filtros: nuevosFiltros }, () => {
      this.buscarInsumos('', false);
    });
  };

  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      filtrarPorCategorias,
      cargarAlAbrir,
      ...restProps
    } = this.props;

    let valorMostrado = this.props.value;
    let placeholderMostrado = placeholder;

    const insumoSeleccionado = this.state.opciones.find(
      (insumo) => insumo._id === this.props.value
    );
    const leyendaClienteEquivalencia = insumoSeleccionado?.equivalenciaClienteId
      ? `Cliente: ${insumoSeleccionado.equivalenciaClienteNombre || "—"}`
      : null;

    if (this.esIdMongoDB(this.props.value) && !this.state.opciones.find(insumo => insumo._id === this.props.value)) {
      if (this.state.cargando) {
        valorMostrado = undefined; // No mostrar valor
        placeholderMostrado = "Buscando insumo...";
      } else if (!this.state.primerCarga) {
        valorMostrado = undefined;
        placeholderMostrado = "Cargando...";
      }
    }

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      onSearch: this.buscarInsumos,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando insumos...
          </div>
        </div>
      ) : this.state.primerCarga
        ? (this.props.clienteId ? 'Este cliente no tiene insumos configurados' : 'No se encontraron insumos')
        : null,
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    const selectElement = (
      <Select
        className={`custom-disabled-select select-insumo-wrap ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={600}
        disabled={disabled || this.state.primerCarga}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        mode={mode}
        optionLabelProp={this.props.ocultarCodigoYUnidad ? 'label' : undefined} // label si se ocultan código y unidad
        {...propsNuevas}
        {...restProps}
        value={valorMostrado} // Usar valor calculado
        onChange={(value) => {
          const insumo = this.state.opciones.find((insumo) => insumo._id === value);
          this.setState({
            opciones: insumo ? [insumo] : []
          });
          this.props.onChange(value, insumo)
        }}
        placeholder={placeholderMostrado} // Usar placeholder calculado
        style={filtrarPorCategorias ? { ...estiloFinal, flex: 1, minWidth: 0 } : estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarInsumos(this.props.value || '', false, true);
          }
        }}
        onDropdownVisibleChange={(abierto) => {
          // Con `insumoPreCargado` el select arranca con una sola opción, para no
          // disparar un POST por renglón al montar. La primera vez que el usuario
          // abre el desplegable sí traemos el catálogo; el insumo actual se
          // conserva vía insumoPrevioAlCambiarCliente si no viene en los primeros.
          if (abierto && this.props.insumoPreCargado && !this.yaCargoAlAbrir) {
            this.yaCargoAlAbrir = true;
            this.insumoPrevioAlCambiarCliente = this.props.insumoPreCargado;
            this.buscarInsumos('', false, false, true);
          } else if (abierto && !this.yaCargoAlAbrir && this.usaCargaAlAbrir()) {
            // `cargarAlAbrir` sin insumo precargado: igual, la primera apertura trae el
            // catálogo conservando el insumo que ya estuviera elegido.
            this.yaCargoAlAbrir = true;
            this.insumoPrevioAlCambiarCliente = this.opcionSeleccionadaActual();
            this.buscarInsumos('', false, false, true);
          }
          if (this.props.onDropdownVisibleChange) {
            this.props.onDropdownVisibleChange(abierto);
          }
        }}
      >
        {this.state.opciones.length > 0 ? this.state.opciones.map((insumo) => {
          const textoBase = this.props.usarSistema
            ? (insumo.stringBuscarSistema || insumo.stringBuscar)
            : insumo.stringBuscar;
          const esInventariable = typeof this.props.tiposInsumos === 'string' && this.props.tiposInsumos.toLowerCase().includes('inventariable');
          let colorFondoOpcion;
          if (esInventariable) {
            if (insumo.compra) colorFondoOpcion = '#f6ffed'; // verde leve
            else if (insumo.venta) colorFondoOpcion = '#fff1f0'; // rojo leve
          }
          const infoTipoMatriz = insumo.matriz ? tipoMatrizInfo(insumo.tipoMatriz) : null;
          let labelSeleccionado = textoBase;
          if (this.props.ocultarCodigoYUnidad && typeof labelSeleccionado === 'string') { // Solo modificar el label si es string y se ocultan código y unidad
            if (insumo.unidad) {
              const unidadStr = typeof insumo.unidad === 'object' && insumo.unidad !== null
                ? (insumo.unidad.nombre || insumo.unidad.descripcion || '')
                : String(insumo.unidad);
              if (unidadStr) {
                const escapedUnidad = unidadStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                labelSeleccionado = labelSeleccionado.replace(new RegExp(`\\s*[-–—]\\s*${escapedUnidad}\\s*$`), ''); // Eliminar " - Unidad" al final
                labelSeleccionado = labelSeleccionado.replace(new RegExp(`\\s*\\(${escapedUnidad}\\)\\s*$`), '');
              }
            }
            [insumo.claveClienteAlternativa, insumo.clave].forEach((clave) => {
              if (clave === undefined || clave === null || clave === '') return;
              const escapedClave = String(clave).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
              labelSeleccionado = labelSeleccionado.replace(new RegExp(`^\\s*${escapedClave}\\s*[-–—]\\s*`), ''); // Eliminar "Clave - " al inicio
            });
            if (insumo.codigo !== undefined && insumo.codigo !== null && insumo.codigo !== '') {
              const escapedCodigo = String(insumo.codigo).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
              labelSeleccionado = labelSeleccionado.replace(new RegExp(`^\\s*${escapedCodigo}\\s*[-–—]\\s*`), ''); // Eliminar "Código - " al inicio
            }
          }
          return (
            <Option
              key={insumo._id}
              value={insumo._id}
              label={labelSeleccionado}
              style={colorFondoOpcion ? { backgroundColor: colorFondoOpcion } : undefined}
            >
              {textoBase}
              {insumo.matriz && (
                <>
                  <Tag style={{ marginLeft: 6 }} color="blue">v{insumo.versionNumero || 1}</Tag>
                  <Tag color={insumo.autorizado ? "green" : "orange"}>
                    {insumo.autorizado ? "Autorizada" : "Borrador"}
                  </Tag>
                </>
              )}
              {infoTipoMatriz && (
                <Tag color={infoTipoMatriz.color}>{infoTipoMatriz.label}</Tag>
              )}
              {insumo.equivalenciaClienteId && (
                <span style={{ marginLeft: 6, color: '#bbb', fontSize: 12 }}>
                  {insumo.equivalenciaClienteNombre || "Cliente"}
                </span>
              )}
            </Option>
          );
        }) : (
          <Option key={0} value={0} disabled>
            No se encontraron insumos
          </Option>
        )}
      </Select>
    );

    const leyendaEquivalencia = leyendaClienteEquivalencia && (
      <div style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>
        {leyendaClienteEquivalencia}
      </div>
    );

    if (!filtrarPorCategorias) {
      return (
        <>
          {selectElement}
          {leyendaEquivalencia}
        </>
      );
    }

    return (
      <>
      <Input.Group
        compact
        style={{ display: "flex", width: width || "100%", alignItems: "center" }}
      >
        {selectElement}
        <FiltroCategoriasInsumosItem
          filtros={this.state.filtros}
          onChange={this.onFiltrosChange}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          disabled={disabled}
          buttonStyle={{ width: 28, height: 28, marginLeft: 5, flexShrink: 0 }}
        />
      </Input.Group>
      {leyendaEquivalencia}
      </>
    );
  }
}

export default SelectInsumosItem;
